module.exports = __webpack_public_path__ + "static/media/be4c44c0.jpg";